import { authClient, API } from "../index";

// Count all tags
export const countTags = () => {
  return authClient().get(`${API}/tag/count`);
};

// Get all tags
export const getTags = () => {
  return authClient().get(`${API}/tag`);
};

// Get tag by id
export const getTagById = (id) => {
  return authClient().get(`${API}/tag/${id}`);
};

// Update tag
export const updateTag = (id, tag) => {
  return authClient().put(`${API}/tag/${id}`, tag);
};

// Create tag
export const postTag = (tag) => {
  return authClient().post(`${API}/tag`, tag);
};

// Delete tag
export const deleteTag = (id) => {
  return authClient().delete(`${API}/tag/${id}`);
};

// Change status tag
export const changeStatusTag = async (id, active) => {
  return authClient().put(`${API}/tag/change-status/${id}`, { active });
};
